import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { faAlarmClock } from "@fortawesome/pro-regular-svg-icons";

import { insightBannerColors } from "@utilifeed/components/propai";
import { NormalizedAlert } from "@core/apis/PropAI/types/alerts.type";

import { ALERT_CONFIG } from "./alertConfig";
import { CheckItemsList } from "./CheckItemsList";
import { InsightTableCard } from "./InsightTableCard";
import { TableRowLayout } from "./TableRowLayout";

type AlertsTableProps = Readonly<{
  alerts: NormalizedAlert[];
}>;

export function AlertsTable({ alerts }: AlertsTableProps) {
  const { t } = useTranslation(["propai_insights"]);

  if (alerts.length === 0) {
    return null;
  }

  const columns = [
    { label: t("we_have_noticed_that"), width: "20%" },
    { label: t("description"), width: "40%" },
    { label: t("recommended_action"), width: "40%" },
  ];

  return (
    <Grid item xs={12}>
      <InsightTableCard
        title={t("alerts")}
        icon={faAlarmClock}
        testId="alerts-table"
        bannerColor={insightBannerColors.alerts}
        columns={columns}
      >
        {alerts.map((alert) => {
          const config = ALERT_CONFIG[alert.type];
          const recommendations = (
            <>
              {config.reasonIntro && (
                <Typography variant="bodyMedium" paragraph>
                  {t(config.reasonIntro)}
                </Typography>
              )}
              <CheckItemsList checkItems={config.checkItems} t={t} />
            </>
          );

          return (
            <TableRowLayout
              key={alert.uid}
              title={t(config.title)}
              description={alert.summary}
              recommendations={recommendations}
            />
          );
        })}
      </InsightTableCard>
    </Grid>
  );
}
